import { makeStyles } from "@mui/styles"
import { colors } from "../../utils"

const useStyles = makeStyles((theme) => ({
  card: {
    margin: "16px auto",
    width: "80%",
    "&.MuiPaper-root": {
      boxShadow: "0px 3px 6px #00000029",
      border: "0.5px solid #C0C0C0",
      borderRadius: "10px",
    },
    [theme.breakpoints.down("lg")]: {
      flexDirection: "column",
    },
    [theme.breakpoints.up("xl")]: {
      width: "60%",
    },
  },

  bgCheck: {
    backgroundColor: colors.deepGreen,
    color: colors.white,
    minWidth: "100px",
  },

  bgUnCheck: {
    backgroundColor: colors.primaryLighten,
    color: colors.white,
    minWidth: "100px",
  },

  typeContainer: {
    padding: "23px 10px",
    textAlign: "center",
  },

  responseContainerCheck: {
    backgroundColor: colors.green,
    height: "30%",
    paddingTop: "3px",
  },

  responseContainerUnCheck: {
    backgroundColor: colors.primaryDarken,
    height: "30%",
    paddingTop: "3px",
  },

  response: {
    "&.MuiTypography-root": {
      fontSize: "14px",
      textAlign: "center",
    },
  },

  type: {
    "&.MuiTypography-root": {
      fontWeight: "bold",
    },
  },

  titles: {
    "&.MuiTypography-root": {
      fontWeight: "bold",
    },
  },

  info: {
    "&.MuiCardContent-root": {
      padding: "24px",
    },
  },

  text: {
    alignItems: "center",
    color: colors.greyStrong,
    width: "100%",
    justifyContent: "space-around",
  },

  subtitles: {
    textAlign: "right",
  },

  ticketNotFound: {
    minHeight: "94px",
    textAlign: "center",
    [theme.breakpoints.down("lg")]: {
      "&.MuiTypography-root": {
        fontSize: "1.2rem",
      },
    },
  },
}))

export default useStyles
